// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"1142a5d5","717":"c1c52232","829":"80a42b35","913":"5f5fe264"}[chunkId] + ".chunk.js";
};